var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "modal-close-btn-point" }, [
        _c(
          "div",
          {
            staticClass: "modal-close-btn-container",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("SVGModalClose")],
          1
        )
      ]),
      _vm._v(" "),
      _c("UserInfo"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "profile-btn-grid" },
        [
          _c(
            "router-link",
            {
              staticClass:
                "modal-button profile-btn modal-button-auto-width hide-underline",
              attrs: { to: "/configurator_lite/projects", target: "_blank" }
            },
            [_vm._v("\n            Lite Версия\n        ")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass:
                "modal-button modal-button-auto-width profile-btn hide-underline",
              attrs: { to: "/configurator/projects", target: "_blank" }
            },
            [_vm._v("\n            Pro Версия\n        ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "profile-btn-grid" }, [
        _c(
          "div",
          {
            staticClass:
              "modal-button modal-button-auto-width button-logout hide-underline",
            on: { click: _vm.logOut }
          },
          [_vm._v("\n            Выйти из профиля\n        ")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }